var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './ChangeCountsRow.scss';
import { ChangeCount } from './ChangeCount';
import classNames from 'classnames';
import { getSonarObjectTypeLabelPlural } from '@sonar-software/sonar-ts-lib';
import { getTimelineSummarySelector } from '@timeline/@arch/selectors';
import { SonarText } from '@ui/text';
import { TimelineChangeType } from '@sonar-software/sonar-core';
import { Col, Row } from 'antd';
import React, { useCallback } from 'react';
import { TIMELINE_CHANGE_TYPE_ORDER } from '@timeline/@arch/lib';
import { useBoolean, useSonarSelector } from '@hooks';
export const ChangeCountsRow = ({ counts, highlightedChangeType, onClick, onClickObjectType, params }) => {
    var _a, _b;
    const { sonarObjectType } = counts, changes = __rest(counts, ["sonarObjectType"]);
    const summary = useSonarSelector(getTimelineSummarySelector.data);
    const title = (_a = getSonarObjectTypeLabelPlural(sonarObjectType)) !== null && _a !== void 0 ? _a : '';
    const [highlight, setHighlight] = useBoolean();
    const { discovered, modified, vanished } = changes;
    const rowCounts = [discovered, modified, vanished];
    const filtered = Boolean(Object.keys((_b = params.objectFilter) !== null && _b !== void 0 ? _b : {}).length);
    const handleOnClickType = useCallback(() => {
        onClickObjectType(sonarObjectType);
    }, [onClickObjectType, sonarObjectType]);
    return (React.createElement("div", { className: 'change-counts-row' },
        React.createElement(Row, { className: 'object-type-label' },
            React.createElement(SonarText, { className: 'h3 clickable', onClick: handleOnClickType, onMouseEnter: setHighlight.on, onMouseLeave: setHighlight.off }, title)),
        React.createElement(Row, { className: classNames('change-counts', { highlight }), gutter: 8, justify: 'space-evenly', wrap: false }, rowCounts.map((changeCount, index) => {
            var _a, _b;
            const changeType = TIMELINE_CHANGE_TYPE_ORDER[index] || TimelineChangeType.Discovered;
            const key = `${sonarObjectType}-${changeType}`;
            const selected = (_b = (_a = params.objectFilter) === null || _a === void 0 ? void 0 : _a[sonarObjectType]) === null || _b === void 0 ? void 0 : _b[changeType];
            const highlighted = highlightedChangeType === changeType;
            return (React.createElement(Col, { key: key, span: 8 },
                React.createElement(ChangeCount, { changeType: changeType, count: changeCount, filtered: filtered, highlighted: highlighted, loading: !summary, objectType: sonarObjectType, onClick: onClick, selected: selected })));
        }))));
};
